<template>
  <v-app class="no-print">
    <r-app-msg :msg="appMsg"></r-app-msg>
    <v-content class="app-bg">
      <r-navbar></r-navbar>
      <v-container v-if="appLoading" fill-height align-center>
        <v-layout row justify-center align-center>
          <v-flex class="text-xs-center" xs7 sm4 md3 lg2>
            <span class="loading-text secondary--text caps spaced">Loading</span>
            <v-progress-linear class="mt-2" color="secondary" height="3" indeterminate></v-progress-linear>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else class="navbar-fix" fluid grid-list-xs>
        <v-layout class="pt-3" row justify-center>
          <transition name="fade" mode="out-in" appear>
            <router-view></router-view>
          </transition>
        </v-layout>
      </v-container>
    </v-content>
    <r-footer></r-footer>
  </v-app>
</template>

<script>
import Navbar from './components/general/Navbar.vue'
import Footer from './components/general/Footer.vue'
import AppMsg from './components/general/AppMsg.vue'
export default {
  components: {
    rNavbar: Navbar,
    rFooter: Footer,
    rAppMsg: AppMsg
  },
  computed: {
    appLoading () {
      return this.$store.getters.loading
    },
    appMsg () {
      return this.$store.getters.appMsg
    }
  },
  beforeMount () {
    this.load()
  },
  beforeDestroy () {
    this.$store.dispatch('stopClock')
  },
  methods: {
    load () {
      this.$store.dispatch('loadApp')
    }
  }
}
</script>

<style scoped>
html {
  overflow-y: auto;
}
.navbar-fix {
  margin-top: 64px;
}
.app-bg {
  /* background: linear-gradient(#0288D1, #FAFAFA) fixed; */
  background: linear-gradient(#B39DDB, #FAFAFA) fixed;
}
.loading-text {
  font-size: 150%;
  line-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue